export default {"src":"/_next/static/media/wallet.5cce472a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};